import {screensharingStream} from '@stream'

export default function useScreensharingStream () {
  return {
    // inherited
    video: screensharingStream.video,
    start: screensharingStream.start,
    stop: screensharingStream.stop,
    updatedAt: screensharingStream.updatedAt
  }
}
